import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/permits',
    name: 'Permit',
    component: {
      name: 'AdminPermit',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'permit',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminPermitIndex',
        component: () => import('../views/admin/PermitAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminPermitNew',
        component: () => import('../views/admin/PermitAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminPermitIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminPermitShow',
        component: () => import('../views/admin/PermitAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminPermitIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminPermitDetails',
            component: () => import('../views/admin/PermitAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminPermitIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminPermitEdit',
            component: () => import('../views/admin/PermitAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminPermitDetails' },
            },
          },
          {
            path: 'attachments',
            name: 'AdminPermitAttachments',
            component: () => import('../views/admin/attachment/PermitAttachments.vue'),
            meta: {
              resource: 'attachment',
              backRoute: { name: 'AdminPermitIndex' },
            },
          },
          {
            path: 'attachments/edit',
            name: 'AdminPermitAttachmentsEdit',
            component: () => import('../views/admin/attachment/PermitAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'AdminPermittAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
          {
            path: 'risks',
            name: 'AdminPermitRisks',
            component: () => import('../views/admin/risk/PermitRisks.vue'),
            meta: {
              backRoute: { name: 'AdminPermitIndex' },
              resource: 'risk',
            },
          },
          {
            path: 'permit_measures',
            name: 'AdminPermitPermitMeasurements',
            component: () => import('../views/admin/permitMeasure/PermitPermitMeasures.vue'),
            meta: {
              backRoute: { name: 'AdminPermitIndex' },
              resource: 'permit_measure',
            },
          },
          {
            path: 'permit_extensions',
            name: 'AdminPermitPermitExtensions',
            component: () => import('../views/admin/permitExtension/PermitExtensionIndex.vue'),
            meta: {
              backRoute: { name: 'AdminPermitIndex' },
              resource: 'permit_extension',
            },
          },
          {
            path: 'approvals',
            name: 'AdminPermitApprovals',
            component: () => import('../views/admin/approval/PermitApprovals.vue'),
            meta: {
              backRoute: { name: 'AdminPermitIndex' },
              resource: 'approval',
            },
          },
         {
            path: 'work_place_checks',
            name: 'AdminPermitWorkPlaceChecks',
            component: () => import('../views/admin/workPlaceCheck/PermitWorkPlaceChecks.vue'),
            meta: {
              backRoute: { name: 'AdminPermitIndex' },
              resource: 'work_place_check',
            },
          },
           {
            path: 'gas_measurements',
            name: 'AdminGastestSubstances',
            component: () => import('../views/admin/gastestSubstances/GastestSubstances.vue'),
            meta: {
              backRoute: { name: 'AdminPermitIndex' },
              resource: 'gas_measurement',
            },
          },
        ],
      },
    ]
  },
  {
    path: 'user/permits',
    name: 'UserPermit',
    component: {
      name: 'UserPermit',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'permit',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserPermitIndex',
        component: () => import('../views/user/PermitUserIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'UserPermitNew',
        component: () => import('../views/user/PermitUserInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'UserPermitIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'UserPermitShow',
        component: () => import('../views/user/PermitUserShow.vue'),
        meta: {
          backRoute: {
            name: 'UserPermitIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'UserPermitDetails',
            component: () => import('../views/user/PermitUserDetails.vue'),
            meta: {
              backRoute: { name: 'UserPermitIndex' },
            },
          },
          {
            path: 'edit',
            name: 'UserPermitEdit',
            component: () => import('../views/user/PermitUserInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'UserPermitDetails' },
            },
          },
          {
            path: 'attachments',
            name: 'UserPermitAttachments',
            component: () => import('../views/user/attachment/PermitAttachments.vue'),
            meta: {
              backRoute: { name: 'UserPermitIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'risks',
            name: 'UserPermitRisks',
            component: () => import('../views/user/risk/PermitRisks.vue'),
            meta: {
              backRoute: { name: 'UserPermitIndex' },
              resource: 'risk',
            },
          },
          {
            path: 'permit_measures',
            name: 'UserPermitPermitMeasurements',
            component: () => import('../views/user/permitMeasure/PermitPermitMeasures.vue'),
            meta: {
              backRoute: { name: 'UserPermitIndex' },
              resource: 'permit_measure',
            },
          },
          {
            path: 'approvals',
            name: 'UserPermitApprovals',
            component: () => import('../views/user/approval/PermitApprovals.vue'),
            meta: {
              backRoute: { name: 'UserPermitIndex' },
              resource: 'approval',
            },
          },
        ],
      },
    ]
  },
];
OCRoutes.forEach(route => router.addRoute('OC', route));